import { Tag } from 'primereact/tag';
import { Link } from 'react-router-dom';

import { ResponsiveImage } from '@/components/common';
import { productDetailRoute } from '@/config/routes';
import type { ProductCardModel } from '@/features/catalog/api';

const badgeLabels = {
  bestseller: 'Bestseller',
  new: 'New',
  popular: 'Popular',
  seasonal: 'Seasonal',
} as const;

export function ProductCard({ product }: { product: ProductCardModel }) {
  const badge = product.badges[0];

  return (
    <article className="product-card">
      <Link
        to={productDetailRoute(product.category, product.slug)}
        aria-label={`View ${product.name}`}
      >
        <div className="product-card__image-wrap">
          <ResponsiveImage src={product.imageUrl} alt={product.imageAlt} width={800} height={640} />
          {badge && <Tag className="product-card__badge" value={badgeLabels[badge]} />}
        </div>
        <div className="product-card__body">
          {product.customizable && (
            <span className="product-card__customizable">
              <i className="pi pi-sparkles" aria-hidden="true" /> Personalize it
            </span>
          )}
          <h3>{product.name}</h3>
          <p>{product.shortDescription}</p>
          <div className="product-card__footer">
            <span>
              <small>Starting at</small> {product.startingPriceLabel.replace(/^From /, '')}
              {product.compareAtPriceLabel && <del>{product.compareAtPriceLabel}</del>}
            </span>
            <i className="pi pi-arrow-right" aria-hidden="true" />
          </div>
        </div>
      </Link>
    </article>
  );
}
